export const tabTypes = {
  ABOUT: "about",
  ALERTS: "alerts",
  CHECKLIST: "checklist",
  IMAGES: "images",
  VIDEOS: "videos",
  ALGORITHMS: "algorithms",
  DETAILS: "details",
  TABLES: "tables",
};
